<script setup lang="ts">
import { computed } from 'vue';
import { IonSpinner } from '@ionic/vue';
import { useUser } from '@/common/composables/useUser';
import { useLocale } from '@/common/composables/useLocale';
import Button from '@/common/components/ui/button/Button.vue';
import IconRenderer from '@/common/components/ui/icon/IconRenderer.vue';

const { isAuthenticated, isLoading, userName, login, logout } = useUser();
const { t } = useLocale();

const buttonLabel = computed(() => {
  if (isLoading.value) return t('auth.processing');
  return isAuthenticated.value ? t('auth.logout', { username: userName.value }) : t('auth.connect');
});

const handleAuthAction = async () => {
  if (isAuthenticated.value) {
    await logout();
  } else {
    await login();
  }
};
</script>

<template>
  <Button
    @click="handleAuthAction"
    :disabled="isLoading"
    :color="isAuthenticated ? 'medium' : 'primary'"
    type="primary"
  >
    <IonSpinner v-if="isLoading" name="dots" />
    <template v-else>
      <IconRenderer
        :name="isAuthenticated ? 'log-out-outline' : 'log-in-outline'"
        size="medium"
        cssColor="var(--ion-text-color-contrast)"
        class="icon-button"
      />
      <span class="label-button">
        {{ buttonLabel }}
      </span>
    </template>
  </Button>
</template>

<style scoped>
.label-button {
  color: var(--ion-text-color-contrast);
  font-size: 1rem;
  text-transform: uppercase;
  padding-right: 10px;
  margin-left: 10px;
}

.icon-button {
  font-size: 1.2rem;
  padding-left: 10px;
}
</style>
